import { render, staticRenderFns } from "./leftCode.vue?vue&type=template&id=30995c48&scoped=true"
import script from "./leftCode.vue?vue&type=script&lang=js"
export * from "./leftCode.vue?vue&type=script&lang=js"
import style0 from "./leftCode.vue?vue&type=style&index=0&id=30995c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30995c48",
  null
  
)

export default component.exports